import type { Database } from 'node-sqlite3-wasm';
import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { getSymbolIndexParentContext } from '../sqlite/symbol-index-sqlite.js';
import { listEffectiveIndexedFilePaths } from '../storage/symbol-parent-file-map.js';

export function listWorkspaceFiles(db: Database, workspacePath: string, includePath: string): Set<string> {
  const files = new Set<string>([includePath.replace(/\\/g, '/')]);

  const normalizedWorkspace = normalizeResolvedPath(workspacePath);
  const parentRow = db.get('SELECT id FROM file_index_parent_path WHERE path = ?', [normalizedWorkspace]) as
    | { id: number | bigint }
    | null;
  if (parentRow != null) {
    const fromIndex = db.all('SELECT path FROM file_index_child_path WHERE parent_id = ?', [
      Number(parentRow.id),
    ]) as Array<{ path: string }>;
    for (const row of fromIndex) files.add(row.path.replace(/\\/g, '/'));
  }

  const ctx = getSymbolIndexParentContext(db, normalizedWorkspace);
  if (ctx != null) {
    for (const filePath of listEffectiveIndexedFilePaths(db, ctx)) {
      files.add(filePath.replace(/\\/g, '/'));
    }
  }

  return files;
}
